import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ApiResponse } from '../models/api.model';
import { ServiceChargesModalComponent } from './modal/service-charges-modal.component';
import { ServiceCharge } from './models/service-charge.model';
import { ServiceChargesService } from './services/service-charges.service';

@Component({
  selector: 'app-service-charges',
  templateUrl: './service-charges.component.html',
  styleUrls: ['./service-charges.component.scss'],
})
export class ServiceChargesComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private readonly modalService = inject(BsModalService);
  private readonly serviceChargesService = inject(ServiceChargesService);
  private readonly toastr = inject(ToastrService);

  private subscriptions: Array<Subscription>;
  private bsModalRef?: BsModalRef;
  public serviceCharges: ServiceCharge[] = [];

  ngOnInit() {
    this.serviceCharges = this.route.snapshot.data['serviceCharges'];
  }

  ngOnDestroy(): void {
    this.subscriptions?.forEach(o => o.unsubscribe());
  }

  getDescription(charge: ServiceCharge): string {
    return `${charge.amount} ${charge.amountUnit === 'percent' ? '%' : 'USD'} per ${charge.applyPer}, up to ${charge.capAmount} ${charge.capAmountUnit}`;
  }

  openModal(selectedServiceCharge?: ServiceCharge) {
    const modalConfig: ModalOptions = {
      animated: true,
      backdrop: true,
      ignoreBackdropClick: true,
      initialState: {
        selectedServiceCharge,
        serviceCharges: this.serviceCharges,
      },
      class: 'service-charges-modal',
    };
    this.bsModalRef = this.modalService.show(
      ServiceChargesModalComponent,
      modalConfig
    );

    this.bsModalRef.onHide.subscribe(() => {
      if (this.bsModalRef.content.closeReason === 'success') {
        this.serviceCharges = this.bsModalRef.content.serviceCharges;
      }
    });
  }

  deleteServiceCharge(serviceCharge: ServiceCharge) {
    if (confirm('Are you sure you want to delete this service charge?')) {
      const serviceCharges = this.serviceCharges.filter(
        c => c.id !== serviceCharge.id
      );

      this.serviceChargesService
        .createOrUpdateServiceCharge(serviceCharges)
        .subscribe({
          next: (res: ApiResponse<ServiceCharge[]>) => {
            this.serviceCharges = res.data;
            this.toastr.success('Service charge deleted successfully');
          },
          error: () => this.toastr.error('Error deleting service charge'),
        });
    }
  }
}
